import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import QuoteDialog from "@/components/layout/QuoteDialog";
import WhatsAppFloat from "@/components/common/WhatsAppFloat";

export default function Layout() {
  return (
    <div className="min-h-screen bg-gema-black flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <QuoteDialog />
      <WhatsAppFloat />
    </div>
  );
}
